export default __webpack_public_path__ + "static/media/department-logo.7bac3ca0.svg";